import React from "react"
import { ProgressBar as PrimeProgressBar } from "primereact/progressbar"

/** @param {import('primereact/progressbar').ProgressBarProps} props */
const ProgressBar = React.forwardRef((props, ref) => {
  return <PrimeProgressBar ref={ref} {...props} />
})

export default ProgressBar
